import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth, sendPasswordResetEmail } from 'firebase/auth';
import { toast } from 'react-toastify';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const navigate = useNavigate();

  const onChange = e => setEmail(e.target.value);

  const onSubmit = async e => {
    e.preventDefault();

    try {
      const auth = getAuth();

      await sendPasswordResetEmail(auth, email);

      toast.success('Email was sent');
      setEmail('');
      navigate('/login');
    } catch (error) {
      toast.error('Could not send Email');
    }
  };

  return (
    <form className="form" onSubmit={onSubmit}>
      <div className="form__control u-margin-bottom-xl">
        <h4 className="heading-4">E-Mail</h4>

        <input
          type="email"
          name="email"
          id="email"
          className="form__input"
          value={email}
          required
          onChange={onChange}
        />
      </div>

      <div className="form__control">
        <button type="submit" className="btn btn__form">
          Reset Password
        </button>
      </div>
    </form>
  );
}

export default ForgotPassword;
